
export class DeliveryOneCommentDTO{
    public Id?: string = undefined;
    public Comment?: string = undefined;
}